const AWS_URL = 'amazonaws';
const TT_CDN_URL = 'cdn.turbotenant.com';
const TT_DEV_CDN_URL = 'cdn.dev.turbotenant.com';

export const checkForTTAttachmentURL = (attachmentURL) => {
  return (
    attachmentURL?.includes(AWS_URL) || attachmentURL?.includes(TT_CDN_URL) || attachmentURL?.includes(TT_DEV_CDN_URL)
  );
};
